import React, { useState } from "react";
import { Button, DatePicker, Form, Input, Select, message } from "antd";
import Heading from "../../../Components/Heading/Heading";
import TextArea from "antd/es/input/TextArea";
import {
  useGetCustomersQuery,
  useGetBranchesQuery,
  useGetTripTypesQuery,
  useGetCountriesQuery,
  useAddReservationMutation,
} from "../../../redux/Service/api";

const { Option } = Select;

const BookAFlight: React.FC = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const { data: customersData, isLoading: isCustomersLoading } =
    useGetCustomersQuery(undefined);
  const { data: branchesData, isLoading: isBranchesLoading } =
    useGetBranchesQuery(undefined);
  const { data: tripTypesData, isLoading: isTripTypesLoading } =
    useGetTripTypesQuery(undefined);
  const { data: countriesData, isLoading: isCountriesLoading } =
    useGetCountriesQuery(undefined);

  const [addReservation, { isLoading: isAdding }] = useAddReservationMutation();

  const customers = customersData?.ResponseObject || [];
  const branches = branchesData?.ResponseObject || [];
  const tripTypes = tripTypesData?.ResponseObject || [];
  const countries = countriesData?.ResponseObject || [];

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ReserveDate: values.ReserveDate.format("YYYY-MM-DD"),
        CustomerID: values.CustomerID,
        BranchID: values.BranchID,
        ReserveUserID: 0,
        TripTypeID: values.TripTypeID,
        TripNo: values.TripNo,
        TripDate: values.TripDate.format("YYYY-MM-DD"),
        CountryFromID: values.CountryFromID,
        CountryToID: values.CountryToID,
        PersonsCount: values.PersonsCount,
        Total: values.Total,
        Payed: values.Payed,
        Notes: values.Notes,
        SitsNumbers: values.SitsNumbers || [],
      };

      const response = await addReservation(requestBody);
      if (response?.data) {
        message.success(" تمت انشاء الحجز بنجاح");
        form.resetFields();
      }
    } catch (error) {
      console.error("Error creating reservation:", error);
      message.error("Failed to create reservation. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
    message.error("Please complete all required fields.");
  };

  return (
    <div>
      <Heading heading="حجز رحله" />
      <div className="container grid grid-cols-1 gap-0">
        <Form
          form={form}
          name="bookFlight"
          layout="vertical"
          initialValues={{ PersonsCount: 1, Total: 0, Payed: 0 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="form-grid"
        >
          <Form.Item
            label="تاريخ الحجز"
            name="ReserveDate"
            rules={[{ required: true, message: "يرجى اختيار تاريخ الحجز" }]}
          >
            <DatePicker size="large" className="w-full" />
          </Form.Item>

          <Form.Item
            label="اسم العميل"
            name="CustomerID"
            rules={[{ required: true, message: "يرجى اختيار العميل" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                (option?.children).toLowerCase().includes(input.toLowerCase())
              }
              size="large"
              placeholder="اختر العميل"
            >
              {customers.map((customer: any) => (
                <Option key={customer.CustomerID} value={customer.CustomerID}>
                  {customer.CustomerName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="الفرع"
            name="BranchID"
            rules={[{ required: true, message: "يرجى اختيار الفرع" }]}
          >
            <Select size="large" placeholder="اختر الفرع">
              {branches.map((branch: any) => (
                <Option key={branch.BranchID} value={branch.BranchID}>
                  {branch.BranchName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="نوع الحجز"
            name="TripTypeID"
            rules={[{ required: true, message: "يرجى اختيار نوع الحجز" }]}
          >
            <Select size="large" placeholder="اختر نوع الحجز">
              {tripTypes.map((type: any) => (
                <Option key={type.TripTypeID} value={type.TripTypeID}>
                  {type.TripTypeName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="اسم الخدمة"
            name="TripNo"
            rules={[{ required: true, message: "يرجى إدخال رقم الخدمة" }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            label="تاريخ الخدمة"
            name="TripDate"
            rules={[{ required: true, message: "يرجى اختيار تاريخ الخدمة" }]}
          >
            <DatePicker size="large" className="w-full" />
          </Form.Item>

          <Form.Item
            label="من"
            name="CountryFromID"
            rules={[{ required: true, message: "يرجى اختيار الدولة" }]}
          >
            <Select size="large" placeholder="اختر الدولة">
              {countries.map((country: any) => (
                <Option key={country.CountryID} value={country.CountryID}>
                  {country.CountryName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="إلى"
            name="CountryToID"
            rules={[{ required: true, message: "يرجى اختيار الدولة" }]}
          >
            <Select size="large" placeholder="اختر الدولة">
              {countries.map((country: any) => (
                <Option key={country.CountryID} value={country.CountryID}>
                  {country.CountryName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="عدد الأفراد"
            name="PersonsCount"
            rules={[{ required: true, message: "يرجى إدخال عدد الأفراد" }]}
          >
            <Input size="large" type="number" />
          </Form.Item>

          <Form.Item
            label="القيمة الإجمالية"
            name="Total"
            rules={[{ required: true, message: "يرجى إدخال القيمة الإجمالية" }]}
          >
            <Input size="large" type="number" />
          </Form.Item>

          <Form.Item
            label="المدفوع"
            name="Payed"
            rules={[{ required: true, message: "يرجى إدخال المدفوع" }]}
          >
            <Input size="large" type="number" />
          </Form.Item>

          <Form.Item label="ملاحظات" name="Notes">
            <TextArea size="large" rows={2} />
          </Form.Item>

          <div className="flex ">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={isAdding}
            >
              حفظ
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default BookAFlight;
